import { createSelector } from "@reduxjs/toolkit"
import { AppRootState } from "./appStore"
import { DashboardLoadItemStatus, DashboardSelectionType, isDashboardSelectionMatch, StatusedAppointment, StatusedTodo, statusedWorkItemKey, WorkItemKey, WorkItemType } from "@fusion-advantage/formlib"

export const selectSelectedStatusedWorkItem = createSelector(
	(state: AppRootState) => state.dashboardControl.selection,
	(state: AppRootState) => state.dashboardData.workItems,
	(selection, workItems): StatusedTodo|StatusedAppointment|null => {
		if(selection.type !== DashboardSelectionType.WorkItem) {
			return null
		}
		switch(selection.key.type) {
			case WorkItemType.Todo:
				return workItems.todo.items?.find(item => {
					let key: WorkItemKey
					if(item.status === DashboardLoadItemStatus.Error) {
						key = item.itemKey
					} else {
						key = statusedWorkItemKey(item)
					}
					return isDashboardSelectionMatch(key, selection)
				}) ?? null
			case WorkItemType.Appointment:
				return workItems.appointment.items?.find(item => {
					const key = statusedWorkItemKey(item)
					return isDashboardSelectionMatch(key, selection)
				}) ?? null
		}
	}
)
